import * as types from './mutation-types';

function transform(type, data) {
  const id = `notification${Date.now()}`;
  return data.message
    ? { ...data, id, type }
    : { id, message: data, type };
}

function isExist(notifications, newNotification) {
  return notifications.some(item => (
    item.message === newNotification.message && item.named === newNotification.named
  ));
}

export const success = ({ commit, state }, payload) => {
  const notification = transform('success', payload);
  if (!isExist(state.items, notification)) {
    commit(types.ADD, notification);
  }
};

export const error = ({ commit, state }, payload) => {
  const notification = transform('error', payload);
  if (!isExist(state.items, notification)) {
    commit(types.ADD, notification);
  }
};

export const warning = ({ commit, state }, payload) => {
  const notification = transform('warning', payload);
  if (!isExist(state.items, notification)) {
    commit(types.ADD, notification);
  }
};

export const info = ({ commit, state }, payload) => {
  const notification = transform('info', payload);
  if (!isExist(state.items, notification)) {
    commit(types.ADD, notification);
  }
};

export const remove = ({ commit }, payload) => {
  commit(types.REMOVE, payload);
};

export default {
  success,
  error,
  warning,
  info,
  remove,
};
